import type { ExternalJobUrlNormalizeFailureReason } from '../../types/external-applied-job';

const MAX_URL_LENGTH = 2048;

export type NormalizeExternalJobUrlResult =
  | { ok: true; url: string }
  | { ok: false; reason: ExternalJobUrlNormalizeFailureReason };

/**
 * Accepts pasted job posting / ATS links. Adds https when the scheme is missing.
 */
export function normalizeExternalJobUrl(input: string): NormalizeExternalJobUrlResult {
  const trimmed = input.trim();
  if (!trimmed) {
    return { ok: false, reason: 'empty' };
  }

  let candidate = trimmed;
  if (!/^[a-z][a-z0-9+.-]*:/i.test(candidate)) {
    candidate = `https://${candidate}`;
  }

  let parsed: URL;
  try {
    parsed = new URL(candidate);
  } catch {
    return { ok: false, reason: 'invalid' };
  }

  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    return { ok: false, reason: 'disallowed_scheme' };
  }

  const href = parsed.href;
  if (href.length > MAX_URL_LENGTH) {
    return { ok: false, reason: 'too_long' };
  }

  return { ok: true, url: href };
}
